import { render } from "./simple_pagination.vue?vue&type=template&id=a0053a04"
import script from "./simple_pagination.vue?vue&type=script&lang=js"
export * from "./simple_pagination.vue?vue&type=script&lang=js"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__